import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'
import ConveyanceMasterKeys from 'src/constants/locale/key/ConveyanceMaster'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  let maxLength35ErrorMessage = translate(
    Namespace.CONVEYANCE_MASTER,
    ConveyanceMasterKeys.Validations.MAX_LENGTH_35
  )

  let alphaNumericSpaceErrorMessage = translate(
    Namespace.CONVEYANCE_MASTER,
    ConveyanceMasterKeys.Validations.ALPHANUMERIC_SPACE
  )

  let regexAlphaNumeric = "^[a-zA-Z0-9]*$"

  return Yup.object({
    licensePlateNo: Yup.string().max(35,maxLength35ErrorMessage).required(requiredMessage).matches(regexAlphaNumeric, alphaNumericSpaceErrorMessage).nullable(),
    countryofRegistration: Yup.string().required(requiredMessage).nullable(),
    state: Yup.string().required(requiredMessage).nullable(),
  })
}

export default makeValidationSchema
